import { render, staticRenderFns } from "./m-change-email.vue?vue&type=template&id=58c830f0&scoped=true&lang=pug"
import script from "./m-change-email.vue?vue&type=script&lang=js"
export * from "./m-change-email.vue?vue&type=script&lang=js"
import style0 from "./m-change-email.vue?vue&type=style&index=0&id=58c830f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c830f0",
  null
  
)

export default component.exports